import React from 'react';
import './VideoPlayer.css'

export default props => {
  const isVimeo = props.block.text && props.block.text.includes('vimeo.com');

  return (
    <div className='video-container'>
      {isVimeo ? (
        <div className="vimeo-video-wrapper">
          <iframe
            src={props.block.text}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="vimeo-video"
          />
        </div>
      ) : (
        <video autoPlay muted loop playsInline src={props.block.text} type={"video/mp4"} className={"media-document mac video"}></video>
      )}
    </div>
  );
};


// <video controls={"1"} autoplay={"0"} src={props.block.text} type={"video/mp4"} class={"media-document mac video"}></video>